/**
 * Formats a given date string into a human-readable format.
 *
 * The output format is "MMM DD, YYYY" (e.g., "Jan 01, 2023").
 *
 * @param inputDate - The date string to format. It should be in a format
 *                    that can be parsed by the JavaScript `Date` object.
 * @returns The formatted date string in "MMM DD, YYYY" format.
 */
export const formatDate = (inputDate: string) => {
  const date = new Date(inputDate);

  const formatted = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  }).format(date);
  return formatted;
};
